import { render, staticRenderFns } from "./TerceirosList.vue?vue&type=template&id=773a3bbb&scoped=true"
import script from "./TerceirosList.vue?vue&type=script&lang=js"
export * from "./TerceirosList.vue?vue&type=script&lang=js"
import style0 from "./TerceirosList.vue?vue&type=style&index=0&id=773a3bbb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "773a3bbb",
  null
  
)

export default component.exports